import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import Profile from './Profile';
import Gallery from './Gallery';
import './Dashboard.css';

export default function Dashboard() {
  const [user, setUser] = useState(null);
  const [hasApiKey, setHasApiKey] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const res = await fetch('/api/user', { headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) {
      const data = await res.json();
      setUser(data);
      setHasApiKey(data.hasKey);
    }
  };

  const showProfileModal = () => {
    document.getElementById('profile-modal').style.display = 'flex';
  };

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <div className="dashboard">
      <nav className="navbar">
        <div className="navbar-brand">
          <img src="/logo.png" alt="Danify Studio" height="40" />
        </div>
        <div className="navbar-links">
          <Link to="/dashboard" className={isActive('/dashboard')}>Character Swap</Link>
          <Link to="/dashboard/avatar" className={isActive('/dashboard/avatar')}>Avatar Live</Link>
          <Link to="/dashboard/image" className={isActive('/dashboard/image')}>Image</Link>
          <Link to="/dashboard/video" className={isActive('/dashboard/video')}>Video</Link>
        </div>
        <div className="navbar-user">
          <button onClick={() => setShowGallery(true)} className="btn-outline">Gallery</button>
          <button onClick={showProfileModal} className="btn-outline">Profile</button>
          <button onClick={logout} className="btn-outline">Logout</button>
        </div>
      </nav>

      <div className="dashboard-container">
        <div className="main-area">
          <Outlet context={{ token, hasApiKey, onUpdate: fetchUser }} />
        </div>
      </div>

      {showGallery && (
        <div className="modal" style={{ display: 'flex' }} onClick={() => setShowGallery(false)}>
          <div className="modal-content gallery-modal" onClick={e => e.stopPropagation()}>
            <span className="close" onClick={() => setShowGallery(false)}>&times;</span>
            <Gallery token={token} />
          </div>
        </div>
      )}

      <Profile token={token} user={user} onUpdate={fetchUser} />
    </div>
  );
}
